import React from 'react'
import { CollectionBlockType } from '../../types'
import { useFilters } from '../../context'
import { CollectionBlockImage } from './CollectionBlockImage'

interface Props {
  block: CollectionBlockType
}

export const CollectionBlock: React.FC<Props> = ({ block }) => {
  const filtersContext = useFilters()

  if (!filtersContext) return null

  return (
    <div className="col-xs-12 col-sm-6 col-md-4">
      <div className="collectionblocks-block">
        <a
          href={`/leather-sofas/${block.linked_range[0].slug}`}
          className={filtersContext.onSale ? 'colblock __sale' : 'colblock'}
        >
          <CollectionBlockImage block={block} />
          <h4 className="colblock-title">{block.title}</h4>
        </a>
      </div>
    </div>
  )
}
